// src/components/LevelBadge.js
import React from 'react';
import { getLevelProgress } from '../utils/gamification';
import './LevelBadge.css';

/**
 * Displays a carrier's current level.
 *
 * size         'sm' | 'md' | 'lg'
 * showProgress  render the XP bar + "X jobs to next level" text
 */
const LevelBadge = ({ jobs = 0, size = 'md', showProgress = false }) => {
  const { level, nextLevel, progress, jobsNeeded } = getLevelProgress(jobs);

  return (
    <div className={`level-badge lb-${size} lb-${level.id}`}>
      <span className="lb-emoji">{level.emoji}</span>
      <span className="lb-label">{level.label.toUpperCase()}</span>

      {showProgress && (
        <div className="lb-progress-wrap">
          <div className="lb-bar-bg">
            <div className="lb-bar-fill" style={{ width: `${progress}%` }} />
          </div>
          {nextLevel ? (
            <span className="lb-progress-text">
              {jobsNeeded} job{jobsNeeded !== 1 ? 's' : ''} to {nextLevel.emoji} {nextLevel.label}
            </span>
          ) : (
            <span className="lb-progress-text lb-max">👑 Maximum level reached</span>
          )}
        </div>
      )}
    </div>
  );
};

export default LevelBadge;
